import { render, staticRenderFns } from "./MarkupModal.vue?vue&type=template&id=41a47a79&scoped=true&"
import script from "./MarkupModal.vue?vue&type=script&lang=ts&"
export * from "./MarkupModal.vue?vue&type=script&lang=ts&"
import style0 from "./MarkupModal.vue?vue&type=style&index=0&id=41a47a79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a47a79",
  null
  
)

export default component.exports